import { useMutation, useQuery, useQueryClient } from 'react-query'
import { deleteDivision, getDivisionGroups, getDivisions, updateDivision } from './divisionsApi'

export const useDivisions = () => {
  return useQuery({
    queryKey: ['divisions'],
    queryFn: getDivisions,
    refetchOnWindowFocus: false})
}

export const useSaveDivisionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateDivision,
    onSuccess: () => {
      queryClient.invalidateQueries(['divisions'])
    },
  })
}

export const useDivisionGroups = () => {
  return useQuery({
    queryKey: ['division-groups'],
    queryFn: getDivisionGroups,
    refetchOnWindowFocus: false,
  })
}

export const useDeleteDivisionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteDivision,
    onSuccess: () => {
      queryClient.invalidateQueries(['divisions'])
    },
  })
}
